import * as t from 'io-ts';

export const FileUrlDynamicType = t.interface({
    url: t.string
});

export type FileUrl = t.TypeOf<typeof FileUrlDynamicType>;
